import type { ServiceGovernanceState } from '@/hooks/useServiceGovernance';

type JobGovernanceInput = {
  blockReason: ServiceGovernanceState['blockReason'];
  entitlementReason: ServiceGovernanceState['entitlementReason'];
  shouldDisable: boolean;
};

/**
 * Exhausting the active-job quota blocks publishing another job, but it must
 * not freeze lifecycle actions that can reduce usage (deactivate/close).
 */
export function isActiveJobQuotaCapacityBlock(
  governance: Pick<JobGovernanceInput, 'blockReason' | 'entitlementReason'>,
): boolean {
  return governance.entitlementReason === 'limit_exceeded'
    && (governance.blockReason === 'limit_exhausted' || governance.blockReason === 'plan_not_entitled');
}

type JobEntitlementInput = {
  allowed: boolean;
  isLoading: boolean;
  reason?: string | null;
  limitType?: string | null;
};

export function isActiveJobEntitlementCapacityBlock(entitlement: JobEntitlementInput): boolean {
  return entitlement.reason === 'limit_exceeded' && entitlement.limitType === 'active';
}

export function shouldBlockJobCreation(entitlement: JobEntitlementInput): boolean {
  return !entitlement.allowed
    && !entitlement.isLoading
    && !isActiveJobEntitlementCapacityBlock(entitlement);
}

export function shouldBlockJobPublish(entitlement: JobEntitlementInput): boolean {
  return !entitlement.allowed && !entitlement.isLoading;
}

export function shouldBlockJobCapacityReducingActions(governance: JobGovernanceInput): boolean {
  return governance.shouldDisable && !isActiveJobQuotaCapacityBlock(governance);
}
